import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import PageRoutes from "../Config/PageRoutes";

const Logo = () => {
    return (
        <Link to={PageRoutes.ROOT}>
            <svg xmlns="http://www.w3.org/2000/svg" width="235" height="90" viewBox="0 0 213 90" style={{ cursor: 'pointer' }}>
                <g id="Group_556" transform="translate(1 -117)">
                    <rect id="Rectangle_626" width="160" height="30" transform="translate(-12 166)" fill="#fb0" />
                    <rect id="Rectangle_625" width="180" height="30" transform="translate(-12 141)" fill="#fb0" />
                    <rect id="Rectangle_624" width="240" height="30" transform="translate(-12 117)" fill="#fb0" />
                    <text id="_Light_Theme_1._Headline_H5" transform="translate(5 120)" fill="#fff" fontSize="17" fontFamily="Roboto-Bold, Roboto, Trebuchet MS" fontWeight="700" letterSpacing="0.007em"><tspan x="0" y="18">The 2020 European Union </tspan><tspan x="0" y="42">report on pesticide </tspan><tspan x="0" y="66">residues in food</tspan></text>
                </g>
            </svg>
        </Link >

    );
}

export default Logo;